import { motion, useReducedMotion } from "motion/react";
import { SPRING_FLUID } from "../lib/motion";

type BlurTextProps = {
  text?: string;
  delay?: number;
  className?: string;
  animateBy?: "words" | "letters";
  "aria-hidden"?: boolean;
};

export function BlurText({
  text = "",
  delay = 0.035,
  className = "",
  animateBy = "words",
  "aria-hidden": ariaHidden
}: BlurTextProps) {
  const shouldReduceMotion = useReducedMotion();
  const segments = animateBy === "words" ? text.split(" ") : text.split("");

  if (shouldReduceMotion) {
    return (
      <p className={`flex flex-wrap ${className}`} aria-hidden={ariaHidden}>
        {text}
      </p>
    );
  }

  return (
    <p className={`blur-text flex flex-wrap ${className}`} aria-hidden={ariaHidden}>
      {segments.map((segment, index) => (
        <motion.span
          key={`${segment}-${index}`}
          initial={{ opacity: 0, y: 14, filter: "blur(10px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{
            ...SPRING_FLUID,
            delay: index * delay
          }}
          className="inline-block"
        >
          {segment === " " ? "\u00A0" : segment}
          {animateBy === "words" && index < segments.length - 1 ? "\u00A0" : null}
        </motion.span>
      ))}
    </p>
  );
}
